import { startOfDay, subYears } from 'date-fns';

import { PerformanceData } from '@ndvr/reporting-api';

export type NetValuePeriod = '1Y' | '3Y' | 'All Time';

export const getNetValueDateRange = (period: NetValuePeriod, today: Date) => ({
    fromInclusive: period === 'All Time' ? undefined : subYears(startOfDay(today), period === '1Y' ? 1 : 3),
    toInclusive: startOfDay(today),
});

const chartAmount = (amount: string | null | undefined) => {
    if (amount == null) return null;
    const value = Number(amount);
    return Number.isFinite(value) ? value : null;
};

export const buildNetValueChart = (history: PerformanceData[], period: NetValuePeriod) => {
    const points = [...history].sort((a, b) => a.reportDate.localeCompare(b.reportDate));
    const openingValue = chartAmount(points[0]?.marketValue);
    const openingCapital = chartAmount(points[0]?.netInvestedCapital);
    const monthlyPoints = new Map<string, PerformanceData>();
    for (const point of points) {
        // Balances are snapshots, not flows: retain each month's latest available observation.
        monthlyPoints.set(point.reportDate.slice(0, 7), point);
    }
    return [...monthlyPoints.values()].map((point) => {
        const capital = chartAmount(point.netInvestedCapital);
        return {
            date: point.reportDate,
            marketValue: chartAmount(point.marketValue),
            netInvested:
                period === 'All Time'
                    ? capital
                    : capital !== null && openingValue !== null && openingCapital !== null
                      ? openingValue + capital - openingCapital
                      : null,
        };
    });
};
